export const getHasTeamsWriteScope = userScopes => userScopes.includes('teams-write');